import { render, staticRenderFns } from "./OperationsDashboard.vue?vue&type=template&id=36b945a4&scoped=true"
import script from "./OperationsDashboard.vue?vue&type=script&lang=js"
export * from "./OperationsDashboard.vue?vue&type=script&lang=js"
import style0 from "./OperationsDashboard.vue?vue&type=style&index=0&id=36b945a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b945a4",
  null
  
)

export default component.exports